import React from 'react'
import AddPowerBreadCrumb from './AddPowerBreadCrumb';
import AddPowerGenerationPlant from './AddPowerGenerationPlant';
function AddPowerGenerationPlantPage() {
    return ( 
        <div className= "container-fluid">
            <AddPowerBreadCrumb />
            <AddPowerGenerationPlant />
        </div>
     );
}

export default AddPowerGenerationPlantPage;